import { render, staticRenderFns } from "./CompaniesListView.vue?vue&type=template&id=4d5b5dd2&scoped=true"
import script from "./CompaniesListView.vue?vue&type=script&lang=js"
export * from "./CompaniesListView.vue?vue&type=script&lang=js"
import style0 from "./CompaniesListView.vue?vue&type=style&index=0&id=4d5b5dd2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d5b5dd2",
  null
  
)

export default component.exports